/**
 * Public barrel export for the ReportsChip molecule (SE-5527).
 * @module components/molecules/ReportsChip
 */
export { default } from "./ReportsChipView";
export type { ReportsChipProps } from "./ReportsChipView";
